import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  AfterViewInit,
  OnInit,
  OnChanges,
} from '@angular/core';
import H from '@here/maps-api-for-javascript';
import { Config } from 'src/app/config';

export enum MapContainer {
  gallery = 'gallery',
  galleryDetail = 'galleryDetail',
  fullscreen = 'fullscreen',
}

const svgMarker = `
	<div style='height: 25px; width: 25px;'>
		<img style='transform:translate(-13px, -31px);' src='${Config.assetCdnRoot}icons/map_marker.svg'>
	</div>
`;

@Component({
  selector: 'vrm-map',
  templateUrl: './vrm-map.component.html',
  styleUrls: ['./vrm-map.component.scss'],
})
export class VrmMapComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() zoom: number = 14.5;
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() interactive: boolean = true;
  @Input() mapContainer: MapContainer = MapContainer.gallery;

  @Output() notify = new EventEmitter();

  @ViewChild('map') mapDiv?: ElementRef;

  private map?: H.Map;
  private timeoutHandle: any;
  public classToApply: string;

  ngOnInit() {
    this.classToApply = this.getClassBasedOnContainer(this.mapContainer);
  }

  ngAfterViewInit(): void {
    if (!this.map && this.mapDiv) {
      const coords: H.geo.IPoint = { lat: this.latitude, lng: this.longitude };
      const platform = new H.service.Platform({
        apikey: Config.hereMapsApiKey,
      });
      const layers = platform.createDefaultLayers();
      this.map = new H.Map(this.mapDiv.nativeElement, (layers as any).vector.normal.map, {
        pixelRatio: window.devicePixelRatio,
        center: coords,
        zoom: this.zoom,
      });

      const icon = new H.map.DomIcon(svgMarker);
      const marker = new H.map.DomMarker(coords, { icon: icon, data: coords });
      this.map.addObject(marker);

      window.addEventListener('resize', () => {
        this.map.getViewPort().resize();
      });
      setTimeout(() => this.map.getViewPort().resize());

      if (this.interactive) {
        this.map.addEventListener('mapviewchange', (ev: H.map.ChangeEvent) => {
          this.notify.emit(ev);
        });
        new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.interactive) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = setTimeout(() => {
        if (this.map) {
          if (changes.zoom !== undefined) {
            this.map.setZoom(changes.zoom.currentValue);
          }
          if (changes.lat !== undefined) {
            this.map.setCenter({ lat: changes.lat.currentValue, lng: this.longitude });
          }
          if (changes.lng !== undefined) {
            this.map.setCenter({ lat: this.latitude, lng: changes.lng.currentValue });
          }
        }
      }, 100);
    }
  }

  getClassBasedOnContainer(container: MapContainer): string {
    let calculatedClass: string;

    if (container === MapContainer.gallery) {
      calculatedClass = 'map-for-gallery';
    }

    if (container === MapContainer.galleryDetail) {
      calculatedClass = 'map-for-gallery-detail';
    }

    if (container === MapContainer.fullscreen) {
      calculatedClass = 'map-full-screen';
    }

    return calculatedClass;
  }
}
